<template>
    <div class="forbidden">
      <h1 style="font-size: 100px;">403</h1>
      <p>Access Denied</p>
      <p>You do not have permission to access this page.</p>
      <a href="/">Go to home page</a>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Forbidden'
  }
  </script>
  
  <style scoped>
  .forbidden {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
  }
  </style>